<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-flex">
        <div class="ts-relative ts-w-full">
          <input
            v-model.trim="search"
            ref="search"
            type="text"
            class="ts-w-full ts-border ts-float-right ts-px-2 ts-py-1 ts-rounded ts-outline-none ts-pr-6"
            :placeholder="$t('wholesale.searchProductList')"
          />
          <span
            class="ts-absolute ts-right-0 ts-mt-1 ts-mr-2"
            style="margin-top: 7px"
            ><i class="fa fa-search"></i
          ></span>
        </div>
      </div>
      <br />
      <div class="max-h ts-px-3">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
              >
                {{ $t('wholesale.productGroup') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
              >
                {{ $t('wholesale.barcode') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
              >
                {{ $t('wholesale.productName') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center"
              >
                {{ $t('wholesale.qtyInStock') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center"
              >
                {{ $t('wholesale.qty') }}
              </th>
              <th
                class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap"
              >
                {{ $t('actions') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              class="ts-border-b ts-border-gray-300"
              v-for="(product, index) in productList"
              :key="index"
            >
              <td class="ts-text-xs">
                {{
                  locale == 'kh'
                    ? product.pro_group_name_kh
                      ? product.pro_group_name_kh
                      : product.pro_group_name_en
                    : product.pro_group_name_en
                }}
              </td>
              <td class="ts-text-xs">{{ product.barcode }}</td>
              <td class="ts-text-xs">
                {{
                  locale == 'kh'
                    ? product.product_name_kh
                      ? product.product_name_kh
                      : product.product_name_en
                    : product.product_name_en
                }}
              </td>
              <td class="ts-text-xs ts-px-2 ts-text-right ts-w-8">
                {{ product.ending_balance }}
              </td>
              <td class="ts-text-center">
                <input
                  v-model="product.quantity"
                  type="number"
                  placeholder="qty"
                  class="ts-w-16 ts-outline-none ts-border-t ts-px-2 ts-py-1 ts-rounded ts-mt-2 ts-text-xs ts-text-center"
                  @keypress.enter="addItem(product)"
                  :readonly="
                    product.is_calculate_stock
                      ? currentStock(product.product_id) <= 0
                      : false
                  "
                />
              </td>
              <td style="width: 1%" class="text-center ts-pl-4">
                <a
                  v-if="allowAddProduct(product)"
                  href="#"
                  v-tooltip="$t('add')"
                  @click.prevent="addItem(product)"
                  class="ts-mb-0"
                >
                  <i class="fa fa-plus"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
    <div v-if="showAlertPromotion">
      <div class="lmask"></div>
      <div class="pro-content">
        <div class="ts-w-64 ts-text-center">
          <h4 class="ts-text-white">Promotion !</h4>
          <h6 class="ts-text-white ts-whitespace-no-wrap">
            {{ promotionContent }}
          </h6>
        </div>
      </div>
    </div>
    <a-modal
      v-model="showModalSelectAnyProduct"
      title="Please chose any product !"
      :centered="true"
      :footer="null"
      :closable="false"
      :maskClosable="false"
    >
      <ts-checkbox
        v-for="(product, index) in promotionProducts"
        v-model="productPromotionSelected"
        :key="index"
        :value="product"
        >{{
          locale == 'kh'
            ? product.product_name_kh
              ? product.product_name_kh
              : product.product_name_en
            : product.product_name_en
        }}</ts-checkbox
      >
      <div class="ts-flex ts-justify-items-end ts-mt-3">
        <ts-button color="primary" @click.prevent="onClickApplyProductPromotion"
          >Apply</ts-button
        >
      </div>
    </a-modal>
  </div>
</template>

<script>
import { debounce, join, sumBy } from 'lodash'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
  name: 'productList',
  props: ['value'],
  data() {
    return {
      promotionContent: '',
      showAlertPromotion: false,
      showModalSelectAnyProduct: false,
      promotionProducts: [],
      productPromotionSelected: [],
      search: '',
      loading: false,
      products: [],
      productInventories: [],
      model: {}
    }
  },
  created() {
    this.model = this.value
    this.fetchProduct()
    this.getPromotion()
    this.$nextTick(() => {
      this.$refs.search.focus()
    })
  },
  computed: {
    ...mapGetters('wholesale/operation', [
      'isDefaultUom',
      'getSalePrice',
      'getDiscount',
      'getFreeItemBuyItem',
      'getCost'
    ]),
    ...mapState('wholesale/operation', [
      'buyItemFreeItem',
      'discountPromotion',
      'freeItemPerAmount',
      'freeCoinPerAmount',
      'setting'
    ]),
    productList() {
      if (!this.setting.is_accounting) {
        return this.products.filter(
          p =>
            !_.includes(
              this.model.product_detail.map(el => el.product_id),
              p.product_id
            )
        )
      }
      return this.products
    },
    currentStock: vm => productId => {
      const proList = vm.products.find(p => p.product_id == productId)
      let productItem = sumBy(
        vm.model.product_detail.filter(p => p.product_id == productId),
        'quantity'
      )
      return proList.ending_balance - productItem
    },
    allowAddProduct: vm => products => {
      const soldOutOfProduction = vm.$store.state.authUser.sys_setting.is_allow_sale_without_stock
      if(soldOutOfProduction) return true

      return products.is_calculate_stock ? vm.currentStock(products.product_id) > 0 : true
    },
    locale() {
      return this.$root.$i18n.locale
    }
  },
  methods: {
    ...mapActions('wholesale/operation', [
      'getProduct',
      'getProductInventory',
      'getPromotion',
      'getFormViewData'
    ]),
    async addItem(product) {
      let hasPromotion = []
      this.$store.commit('wholesale/operation/SET_PRODUCT', product)
      const data = this.serializeData(product)
      hasPromotion.push(await this.addProductWithDiscountPromotion(data))
      hasPromotion.push(await this.addPromotionByItemFreeItem(data))
      if (!hasPromotion.includes(true)) {
        this.model.product_detail.push(data)
      }
      this.$emit('calculate')
      hasPromotion = []
    },
    async fetchProductInventory() {
      this.loading = true
      return this.getProductInventory({
        productId: this.products.map(p => p.product_id),
        stock_out_date: this.model.stock_out_date
      })
        .then(response => {
          const endingProduct = response.data
          this.products.forEach(el => {
            if (endingProduct.hasOwnProperty(el.product_id)) {
              if (endingProduct[el.product_id].length) {
                el.ending_balance = parseFloat(
                  endingProduct[el.product_id][0].ending_balance
                )
              } else {
                el.ending_balance = 0
              }
            } else {
              el.ending_balance = 0
            }
          })
          return response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    fetchProduct() {
      this.loading = true
      this.products = []
      this.getProduct({
        filter: {
          search: this.search
        }
      })
        .then(async response => {
          this.products = response.data
          if (this.model.is_check_back_date) {
            return this.fetchProductInventory()
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    serializeData(product) {
      const uom_id = this.isDefaultUom(product.product_id)
      return {
        product_id: product.product_id,
        product_name_en: product.product_name_en,
        product_name_kh: product.product_name_kh,
        barcode: product.barcode,
        uom_id: uom_id,
        quantity: product.quantity ? product.quantity : 1,
        unit_price: this.getSalePrice({
          product_id: product.product_id,
          uom_id: uom_id
        }),
        discount_type: '%',
        discount_rate: 0,
        discount_amount: 0,
        total_after_discount: 0,
        vat_rate: 0,
        vat_amount: 0,
        grand_total: 0,
        promo_ref_promo_product_id: null,
        promo_type_id: '',
        vat_eligible: product.vat_eligible,
        serial_list: [],
        is_custom: false,
        is_calculate_stock: product.is_calculate_stock,
        has_serial: product.is_generate_unique_serial,
        ending_balance: product.ending_balance,
        cost: parseFloat(
          this.getCost({
            product_id: product.product_id,
            uom_id: uom_id
          })
        )
      }
    },
    async addFreeItemPerAmount() {
      // promo_type_id:3
      this.promotionProducts = []
      if (this.freeItemPerAmount.length) {
        //remove product which discount per amount before add new condition
        const productionProduct = this.model.product_detail.filter(
          detail => detail.promo_type_id == 3
        )
        productionProduct.forEach(el => {
          this.model.product_detail.splice(
            this.model.product_detail.indexOf(el),
            1
          )
        })
        const betweenAmount = this.freeItemPerAmount.find(
          amount =>
            amount.amount_from <= this.model.grand_total &&
            amount.amount_to >= this.model.grand_total &&
            amount.amount_to != null
        )
        const greaterXAmount = this.freeItemPerAmount.find(
          amount =>
            amount.amount_from <= this.model.grand_total &&
            amount.amount_to == null
        )
        if (betweenAmount != undefined && betweenAmount.free_status == 'All') {
          await this.addAllProductOnPromotionFreeItemPerAmount(betweenAmount)
        }

        if (
          greaterXAmount != undefined &&
          greaterXAmount.free_status == 'All'
        ) {
          await this.addAllProductOnPromotionFreeItemPerAmount(greaterXAmount)
        }

        if (betweenAmount != undefined && betweenAmount.free_status == 'Any') {
          betweenAmount.discount_items.forEach(el => {
            this.promotionProducts.push(el)
          })
        }

        if (
          greaterXAmount != undefined &&
          greaterXAmount.free_status == 'Any'
        ) {
          greaterXAmount.discount_items.forEach(el => {
            this.promotionProducts.push(el)
          })
        }

        if (this.promotionProducts.length) {
          this.showModalSelectAnyProduct = true
        }
      }
    },
    async onClickApplyProductPromotion() {
      this.showModalSelectAnyProduct = false
      this.showAlertPromotion = true
      this.promotionContent =
        'Please wait we apply product promotion to your list...'
      const holdingItem = []
      const ids = []
      this.productPromotionSelected.forEach(el => {
        holdingItem[el.product_id] = parseInt(el.quantity)
        ids.push(el.product_id)
      })
      const products = await this.getItemByIdFromServerAddToPromotion(ids)

      products.data.forEach(el => {
        this.$store.commit('wholesale/operation/SET_PRODUCT', el)
        const data = this.serializeData(el)
        data.promo_type_id = 3
        data.unit_price = 0
        data.quantity = parseInt(holdingItem[el.product_id])
        this.model.product_detail.push(data)
      })
      this.promotionProducts = []
      this.productPromotionSelected = []
      this.showAlertPromotion = false
    },
    async addAllProductOnPromotionFreeItemPerAmount(promotion) {
      this.showAlertPromotion = true
      this.promotionContent =
        'You are match with condition free item per amount !'
      const holdingItem = []
      const ids = []
      promotion.discount_items.forEach(el => {
        holdingItem[el.product_id] = parseInt(el.quantity)
        ids.push(el.product_id)
      })
      const products = await this.getItemByIdFromServerAddToPromotion(ids)

      products.data.forEach(el => {
        this.$store.commit('wholesale/operation/SET_PRODUCT', el)
        const data = this.serializeData(el)
        data.promo_type_id = 3
        data.unit_price = 0
        data.quantity = parseInt(holdingItem[el.product_id])
        this.model.product_detail.push(data)
      })
      this.showAlertPromotion = false
    },
    async addPromotionByItemFreeItem(product) {
      const items = this.buyItemFreeItem.find(
        p =>
          p.product_buy_id == product.product_id &&
          p.uom_buy_id == product.uom_id
      )
      if (items) {
        this.showAlertPromotion = true
        this.promotionContent =
          'You are match with condition buy item free item !'
        product.promo_type_id = items.promo_type_id
        const existingProduct = this.checkProductExistingInList(product)
        if (!existingProduct.length) {
          this.model.product_detail.push(product)
        }
        const holdingItem = []
        const ids = []
        items.free_item_list.forEach(el => {
          holdingItem[el.product_free_id] = parseInt(el.free_quantity)
          ids.push(el.product_free_id)
        })
        const products = await this.getItemByIdFromServerAddToPromotion(ids)

        products.data.forEach(el => {
          this.$store.commit('wholesale/operation/SET_PRODUCT', el)
          const data = this.serializeData(el)
          data.promo_ref_promo_product_id = product.product_id
          data.promo_type_id = items.promo_type_id
          data.unit_price = 0
          data.quantity = parseInt(holdingItem[el.product_id])
          this.model.product_detail.push(data)
        })

        this.showAlertPromotion = false
        return true
      }

      return false
    },
    async addProductWithDiscountPromotion(product) {
      const discountPromotion = this.discountPromotion.find(
        d => d.product_id == product.product_id && d.uom_id == product.uom_id
      )
      if (discountPromotion) {
        product.promo_type_id = discountPromotion.promo_type_id
        product.discount_rate = discountPromotion.promo_discount_value
        const products = this.checkProductExistingInList(product)
        if (!products.length) {
          this.model.product_detail.push(product)
        } else {
          products.forEach(el => {
            el.discount_rate = discountPromotion.promo_discount_value
          })
        }
        return true
      }

      return false
    },
    checkProductExistingInList(product) {
      const products = this.model.product_detail.filter(
        p => p.product_id == product.product_id && p.uom_id == product.uom_id
      )

      return products
    },
    getItemByIdFromServerAddToPromotion(ids) {
      return this.getProduct({
        filter: {
          product_id: join(ids, ',')
        }
      })
    }
  },
  watch: {
    'model.grand_total': debounce(function() {
      this.addFreeItemPerAmount()
    }, 500),
    search: debounce(function() {
      this.fetchProduct()
    }, 500)
  }
}
</script>

<style scoped lang="scss">
.max-h {
  height: 240px;
  max-height: 250px;
  overflow: scroll;
}

table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}

table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}

.lmask {
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #000;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: 9998;
  opacity: 0.4;

  &.fixed {
    position: fixed;
  }

  &:before {
    content: '';
    background-color: rgba(0, 0, 0, 0);
    border: 5px solid rgba(0, 183, 229, 0.9);
    opacity: 0.9;
    border-right: 5px solid rgba(0, 0, 0, 0);
    border-left: 5px solid rgba(0, 0, 0, 0);
    border-radius: 50px;
    box-shadow: 0 0 35px #2187e7;
    width: 50px;
    height: 50px;
    -moz-animation: spinPulse 1s infinite ease-in-out;
    -webkit-animation: spinPulse 1s infinite linear;

    margin: -25px 0 0 -25px;
    position: absolute;
    top: 50%;
    left: 50%;
  }

  &:after {
    content: '';
    background-color: rgba(0, 0, 0, 0);
    border: 5px solid rgba(0, 183, 229, 0.9);
    opacity: 0.9;
    border-left: 5px solid rgba(0, 0, 0, 0);
    border-right: 5px solid rgba(0, 0, 0, 0);
    border-radius: 50px;
    box-shadow: 0 0 15px #2187e7;
    width: 30px;
    height: 30px;
    -moz-animation: spinoffPulse 1s infinite linear;
    -webkit-animation: spinoffPulse 1s infinite linear;

    margin: -15px 0 0 -15px;
    position: absolute;
    top: 50%;
    left: 50%;
  }
}

@-moz-keyframes spinPulse {
  0% {
    -moz-transform: rotate(160deg);
    opacity: 0;
    box-shadow: 0 0 1px #2187e7;
  }

  50% {
    -moz-transform: rotate(145deg);
    opacity: 1;
  }

  100% {
    -moz-transform: rotate(-320deg);
    opacity: 0;
  }
}

@-moz-keyframes spinoffPulse {
  0% {
    -moz-transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spinPulse {
  0% {
    -webkit-transform: rotate(160deg);
    opacity: 0;
    box-shadow: 0 0 1px #2187e7;
  }

  50% {
    -webkit-transform: rotate(145deg);
    opacity: 1;
  }

  100% {
    -webkit-transform: rotate(-320deg);
    opacity: 0;
  }
}

@-webkit-keyframes spinoffPulse {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

.pro-content {
  top: 60%;
  left: 40%;
  position: absolute;
  z-index: 9999;
  margin: -8px 0 0 -15px;
}
</style>
